import { Container, Grid, Typography } from "@mui/material";
import React, { Component, ErrorInfo } from "react";
import ContentHeader from "../../components/layout/ContentHeader/ContentHeader";
import Section from "../../components/layout/Section/Section";
import { PAGE } from "../../constants/page";
import ArrowButton from "../../components/ui/ArrowButton/ArrowButton";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Error caught by ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <Section color="dark">
            <ContentHeader title={'500'} subTitle={'Internal Error'} />
          </Section>

          <Section color="light">
            <Container>
              <Grid size={{ sm: 12, lg: 12 }} sx={{ marginTop: '100px', marginBottom: '100px' }}>
                <Typography variant="body1" fontSize={'1.25rem'} marginBottom={'2rem'}>
                  このページは現在ご利用いただけません。
                </Typography>
                <Typography variant="body1">
                  何らかの理由でページを表示できませんでした。<br />
                  一時的な問題の可能性もございますので、時間をおいて再度お試しいただくか、<br />
                  ページ上部・下部のナビゲーション、またはトップページより必要な情報をお探しください。
                </Typography>
              </Grid>
            </Container>
          </Section >

          <Section height="100px" color="light">
            <Container>
              <Grid>
                <Grid size={12} sx={{ textAlign: 'center' }}>
                  <ArrowButton label={PAGE.TOP.NAME} href={PAGE.TOP.PATH} isLeft />
                </Grid>
              </Grid>
            </Container >
          </Section>
        </>
      );
    }

    return this.props.children;
  }
}